import { compose, lifecycle, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { selectors as uiSelectors } from 'state/ui';

import AddressSuggestionsSelector from 'components/AddressModal/components/AddressSuggestionsSelector/component';
import {
  actions as analyticsActions,
  constants as analyticsEvents,
} from 'state/analytics';

const enhance = compose(
  withTranslation('AddressSelector'),
  connect(
    (state, { shipmentKey, stopType, options, suggestionType }) => ({
      loading: uiSelectors.isLoadingAddresses(state, shipmentKey, stopType),
    }),
    {
      sendEvent: analyticsActions.sendEvent,
    }
  ),
  withHandlers(() => ({
    selectAddress:
      ({ onSuggestionClicked, options, sendEvent, suggestionType }) =>
      ({ value }) => {
        onSuggestionClicked(value);
        const { idx } = value;
        sendEvent(
          analyticsEvents.addresses.selectedAddressSuggestion({
            selectedAddressSuggestion: value,
            selectedAddressRank: idx + 1,
            totalNumberOfAddresses: (options || []).length,
            suggestionType,
          })
        );
      },
  })),
  lifecycle({
    componentDidMount() {
      const { options, suggestionType, sendEvent } = this.props;
      sendEvent(
        analyticsEvents.addresses.shownAddressSuggestions({
          numberOfAddressSuggestions: (options || []).length,
          suggestionType,
        })
      );
    },
  })
);

export default enhance(AddressSuggestionsSelector);
